import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

export interface NotificationBarState {
  text: string;
  status: number;
}

const initialState: NotificationBarState = {
  text: "",
  status: 0,
};

export const NotificationBar = createSlice({
  name: "notificationBar",
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<string>) => {
      state.status = 1;
      state.text = action.payload;
    },
    hideNotification: (state) => {
      state.status = 0;
      state.text = "";
    },
  },
});

export const { showNotification, hideNotification } = NotificationBar.actions;

export const selectNotificationStatus = (state: RootState) =>
  state.notification.status;

export const selectNotificationText = (state: RootState) =>
  state.notification.text;

export default NotificationBar.reducer;
